import AirportsInput from './AirportsInput'

export default AirportsInput
